module.exports = __webpack_public_path__ + "static/media/mobileScreenshot02.8ea427a6.jpg";